module.exports = __webpack_public_path__ + "img/i3.2dcb15b8.png";